var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 29.7502C77 27.885 75.25 26.7502 73.75 26.2502C73.5 26.2502 73 26.0002 72.5 26.0002H32.75L29.25 21.5002L28.25 20.5002C27.5 19.7502 26.75 19.2502 25.5 19.2502H12.5C12 19.2502 11.75 19.2502 11.25 19.5002C9.5 19.7502 8 21.7502 8 23.7502V67.5003C8 69.0003 8.5 70.0003 9.5 71.0003C9.5 71.0003 9.5 71.0003 9.75 71.2503C10.5 71.7503 11.5 72.2503 12.75 72.2503H72.75C73.75 72.2503 74.75 72.0003 75.75 71.2503C76.75 70.5003 77.5 69.0003 77.5 67.5003C77.5 60.8329 77 43.5 77 29.7502Z",
    stroke: "#2396E9",
    strokeWidth: 3.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3833 62.5001H66.9036C67.1213 62.5001 67.339 62.7144 67.339 62.9287V64.643C67.339 64.8572 67.1213 65.0715 66.9036 65.0715H38.3833C38.1656 65.0715 37.9478 64.8572 37.9478 64.643V62.9287C37.9478 62.7144 38.1656 62.5001 38.3833 62.5001ZM37.9478 58.0001V56.2858C37.9478 56.0715 38.1656 55.8572 38.3833 55.8572H66.9036C67.1213 55.8572 67.339 56.0715 67.339 56.2858V58.0001C67.339 58.2144 67.1213 58.4287 66.9036 58.4287H38.3833C38.1656 58.4287 37.9478 58.2144 37.9478 58.0001ZM67.339 51.5C67.339 51.5715 66.9036 51.5715 66.6859 51.5715H38.3833C38.1656 51.5715 37.9478 51.3572 37.9478 51.1429V49.4287C37.9478 49.2144 38.1656 49.0001 38.3833 49.0001H66.9036C67.1213 49.0001 67.339 49.2144 67.339 49.4287V51.1429V51.5ZM26.8445 47.7144C26.8445 47.5001 27.0623 47.2858 27.28 47.2858H29.5456C29.7634 47.2858 29.9811 47.5001 29.9811 47.7144V64.4287C29.9811 64.643 29.7634 64.8572 29.5456 64.8572H27.28C27.0623 64.8572 26.8445 64.643 26.8445 64.4287V47.7144ZM19.2246 40.0001C19.2246 39.7858 19.4423 39.5715 19.66 39.5715H21.9257C22.1434 39.5715 22.3611 39.7858 22.3611 40.0001V64.4287C22.3611 64.643 22.1434 64.8572 21.9257 64.8572H19.66C19.4423 64.8572 19.2246 64.643 19.2246 64.4287V40.0001Z",
    fill: "#2396E9",
    stroke: "#2396E9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.751 26.25V15.75C73.751 13.25 71.751 11.25 69.001 11.25H16.001C13.501 11.25 11.501 13.25 11.501 15.75V19.25",
    stroke: "#2396E9",
    strokeWidth: 3.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagement);
export default __webpack_public_path__ + "static/media/project_management.dc59a77ea7e65e52af1f52c574128a32.svg";
export { ForwardRef as ReactComponent };